export default __webpack_public_path__ + "static/media/space.c31109f5.svg";